import { getBoolean } from 'firebase/remote-config';
import { FEATURE_FLAGS } from '@highmark-web/highmark-common';
import { firebaseRemoteConfig } from '../common/firebase/firebase';

export const useFirebaseLeagueConfig = () => {
  // Live Chat Feature Flags
  const liveChatNavigateAway = getBoolean(
    firebaseRemoteConfig,
    FEATURE_FLAGS.LIVE_CHAT_NAVIGATE_AWAY,
  );

  // Wallet Feature Flags
  const walletLiveBalances = getBoolean(
    firebaseRemoteConfig,
    FEATURE_FLAGS.WALLET_ENABLE_NO_NETWORK_LIVE_BALANCES,
  );

  return {
    liveChatNavigateAway,
    walletLiveBalances,
  };
};
